<template>
  <Layout>
    <template v-slot:navigation>
      <topNav />
    </template>
    <template v-slot:content>
      <div
        style="background-image:url('../../assets/images/partner-back.png'); background-size: cover; background-repeat: no-repeat;"
      >
        <div class="container">
          <div class="row" style="padding-top: 10rem; padding-bottom: 10rem">
            <div class="col-md-12">
              <div class="card">
                <form @submit.prevent="submitInfo">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-10 offset-md-1">
                        <h3 class="text-green text-center mb-5">
                          Get Hired By Startup
                        </h3>
                        <div class="form-group">
                          <label for="name" class="bmd-label-floating"
                            >Name</label
                          >
                          <input id="name" type="text" class="form-control" />
                        </div>
                        <div class="form-group">
                          <label for="type" class="bmd-label-floating"
                            >Gender</label
                          >
                          <select id="type" class="form-control">
                            <option value="Individual Investor">Male</option>
                            <option value="Institutional Investor"
                              >Female</option
                            >
                          </select>
                        </div>

                        <div class="form-group">
                          <label for="email" class="bmd-label-floating"
                            >Email</label
                          >
                          <input type="email" id="email" class="form-control" />
                        </div>
                        <div class="form-group">
                          <label for="phone" class="bmd-label-floating"
                            >Phone</label
                          >
                          <input type="text" class="form-control" id="phone" />
                        </div>
                        <div class="form-group">
                          <label for="short_profile" class="bmd-label-floating"
                            >Short Profile</label
                          >
                          <textarea
                            id="short_profile"
                            class="form-control"
                            style="height: 7rem"
                          />
                        </div>
                        <div class="form-group">
                          <label
                            for="organization_name"
                            class="bmd-label-floating"
                            >Name of organization</label
                          >
                          <input
                            type="email"
                            class="form-control"
                            id="organization_name"
                          />
                        </div>
                        <div class="form-group">
                          <label for="notes" class="bmd-label-floating"
                            >Add Notes</label
                          >
                          <textarea
                            class="form-control"
                            id="notes"
                            style="height: 7rem"
                          />
                        </div>

                        <div class="form-group mt-5">
                          <div class="input-group">
                            <div class="custom-file">
                              <input
                                type="file"
                                class="custom-file-input"
                                id="inputGroupFile02"
                              />
                              <label
                                class="custom-file-label"
                                for="inputGroupFile02"
                                aria-describedby="inputGroupFileAddon02"
                                >Attach file</label
                              >
                            </div>
                            <div class="input-group-append">
                              <span
                                class="input-group-text"
                                id="inputGroupFileAddon02"
                                ><i class="fa fa-paperclip text-dark"
                              /></span>
                            </div>
                          </div>
                        </div>

                        <div class="text-center mt-5 mb-5">
                          <button
                            class="btn btn-orange pt-2 pb-2"
                            style="border-radius: 10px;"
                          >
                            Partner with startup
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script>
import layout from "@/components/app-layout";
import navigation from "@/components/topNav";

export default {
  components: {
    Layout: layout,
    topNav: navigation
  },
  data: () => {
    return {
      jobs: []
    };
  },
  methods: {},
  created() {
    document.body.style.background = "#F3F7FF";
  },
  mounted() {}
};
</script>

<style scoped>
.input-group {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
}
.input-group > .custom-file {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}
.input-group > .custom-file,
.input-group > .custom-select,
.input-group > .form-control,
.input-group > .form-control-plaintext {
  position: relative;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  min-width: 0;
  margin-bottom: 0;
}
.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}
.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  opacity: 0;
}
.input-group > .custom-file:not(:last-child) .custom-file-label,
.input-group > .custom-file:not(:last-child) .custom-file-label::after {
  content: '';
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border-bottom: 1px solid #ced4da;
}
.input-group-append {
  margin-left: -1px;
}
.input-group-append,
.input-group-prepend {
  display: -ms-flexbox;
  display: flex;
}
.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group
  > .input-group-prepend:first-child
  > .input-group-text:not(:first-child),
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group-text {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  border-bottom: 1px solid #ced4da;
}
</style>
